import { gql } from '@apollo/client';

/**
 * tt_location_config 承运商/服务层级查询（尾程商服务下拉共用）。
 * - locationType=5 的顶级节点：承运商（code=尾程商枚举名，如 USPS）
 * - parent_id 指向承运商节点的记录：服务（code=服务码，作为分拣规则第三段；label_code 仅展示不参与匹配）
 * 定义与 ops-tool/wms/tt-location-config 下同名 query 一致，这里独立一份避免跨模块依赖。
 */
export type TtLocationConfigItem = {
  id: number;
  parentId: number | null;
  locationType: number;
  code: string;
  name: string;
  labelCode: string | null;
  sortOrder: number | null;
};

export type TtLocationConfigFilterInput = {
  locationType?: number;
  parentId?: number;
  name?: string;
  isDeleted?: boolean;
};

export type TtLocationConfigPageResponse = {
  getTtLocationConfigsWithPagination: {
    content: TtLocationConfigItem[];
    page: number;
    size: number;
    totalElements: number;
    totalPages: number;
    hasNext: boolean;
    hasPrevious: boolean;
  };
};

export type TtLocationConfigChildrenResponse = {
  getTtLocationConfigChildren: TtLocationConfigItem[];
};

export const GET_TT_LOCATION_CONFIGS_WITH_PAGINATION = gql`
  query GetTtLocationConfigsWithPagination(
    $filter: TtLocationConfigFilterInput
    $pageRequest: PageRequestTypeInput
  ) {
    getTtLocationConfigsWithPagination(filter: $filter, pageRequest: $pageRequest) {
      content {
        id
        parentId
        locationType
        code
        name
        labelCode
        sortOrder
      }
      page
      size
      totalElements
      totalPages
      hasNext
      hasPrevious
    }
  }
`;

export const GET_TT_LOCATION_CONFIG_CHILDREN = gql`
  query GetTtLocationConfigChildren($parentId: Long!) {
    getTtLocationConfigChildren(parentId: $parentId) {
      id
      parentId
      locationType
      code
      name
      labelCode
      sortOrder
    }
  }
`;
